import React, { useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { CounterCard, CstmPagination } from "../../../components/Common/Common";
import { Link } from "react-router-dom";

// css
import styles from "./Dashboard.module.scss";

// img
import g1 from "../../../Assets/images/graph.png";
import g2 from "../../../Assets/images/g2.png";
import EarningFeature from "./components/earningFeature";
import { DASHBOARD_REPORT } from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import { LineChart } from "@mui/x-charts/LineChart";
import { getLast7Days } from "../../../utilities/utilities";
import RevenueChart from "./components/RevenueChart";

const Dashboard = () => {
  const [data, setData] = useState();

  const getData = async () => {
    try {
      const res = await DASHBOARD_REPORT();

      if (res?.data?.success) {
        setData(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  useState(() => {});

  useState(() => {
    getData();
  }, []);

  return (
    <>
      <section className="position-relative py-2">
        <Container>
          <Row className="">
            <Col lg="12" className="my-2">
              <EarningFeature data={data} />
            </Col>
            <Col md="12" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded bg-white">
                <div className="cardHead m-0 pb-2 d-flex justify-content-between">
                  <h6 className="m-0 fw-sbold themeBlue">Total Revenue</h6>
                  <h6 className="m-0 fw-sbold themeBlue">Last 7 days</h6>
                </div>
                {/* <img src={g1} alt="" className="img-fluid" /> */}
                <div className="d-flex justify-center">
                  <RevenueChart graphData={data?.graphdata} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
